export default __webpack_public_path__ + "static/media/img-3.a6c85a45.png";